const simulationMonitorEn = {
	simulationMonitorTable: 'Simulation Monitor',
	name: 'Name',
	simulationMonitorEditForm: 'Simulation Monitor',
	basic: 'Basic',
	fields: 'Fields',
	type: 'Type',
	aspect: 'Aspect',
	simulationMonitorLog: 'Simulation Monitor Log',
	readInterval: 'Read Interval',
	maxIterations: 'Max Iterations',
	timeWindow: 'Time Window',
	sigma: 'Sigma',
};

export default simulationMonitorEn;